import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children }) => {
    const { user } = useAuth(); // Ensure `useAuth` is correctly implemented

    // If the user is authenticated, render the children
    if (user) {
        return children;
    }else {
        sessionStorage.setItem('pathtoRedirect', window.location.pathname || '/');
        window.location.href = '/login'; // Redirect to login page
        return null; // Optionally, you can return a loading spinner or message here
    } 
}

export default ProtectedRoute;